import { useApi } from '@omnipresentgroup/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

type UpdateEmployeeCompensationRequest = {
  amount: number;
  currency: string;
  effectiveDate: string;
  hoursOfWork: number;
  jobDescription: string;
  jobTitle: string;
  reason: string;
  notes?: string;
  enabledNotifications?: boolean;
};

export const useEmployeeCompensationMutation = ({
  employeeId,
}: {
  employeeId: string;
}) => {
  const { PATCH } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateEmployeeCompensationRequest) => {
      return PATCH({
        path: `${API_BASE}/${API_PATH}/${employeeId}/compensation`,
        body: payload,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_PATH, employeeId],
      });
    },
  });
};
